import { render, staticRenderFns } from "./RegisterCertGuide.vue?vue&type=template&id=106605df&scoped=true&lang=html&"
import script from "./RegisterCertGuide.vue?vue&type=script&lang=ts&"
export * from "./RegisterCertGuide.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterCertGuide.vue?vue&type=style&index=0&id=106605df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106605df",
  null
  
)

export default component.exports